import SetlistBrowser from 'components/Setlist/SetlistBrowser';
import React from 'react';

const SetlistBrowserPage: React.FC = () => {
  return <SetlistBrowser />;
};

export default SetlistBrowserPage;
